import { render, staticRenderFns } from "./ItemFilterMyPageLayout.vue?vue&type=template&id=4f52c5e7&scoped=true"
import script from "./ItemFilterMyPageLayout.vue?vue&type=script&lang=js"
export * from "./ItemFilterMyPageLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f52c5e7",
  null
  
)

export default component.exports